module.exports = __webpack_public_path__ + "static/media/humidity.2094e517.png";